<template>
    <div class="search_sect meniu_produse">
        <section class="sectiune_mobile containerg">
            <form action="/search">
            <div class="search_relative ">
                <input class="search_header_mobile" type="search" name='keywords' :placeholder="$t('search_food')" />
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'search' }" class="icon_search"/>
            </div>
            </form>
        </section>
        <section class="section_search containerg ">
            
            <div class="titlu_search">
                {{ $t('search_result') }}
            </div>
            <div class="produse " v-if="produse.length > 0">
                <div :dataslug="produs.additional.slug_ro" v-for="produs in produse" :key="produs.id" class="box_produs box_general box_gen_mob"    @click="deschidereModalProdus(produs.id, $event)">
                    <div class="positionrelative box_top">
                        <div v-for="imagine in produs.main_image.slice(0,1)" :key="imagine.thumbnailpath">
                            <img :src="imagine.thumbnailpath"/>
                        </div>
                        <i class="ri-heart-fill heart_absolute favorit element_desktop" :datastatus="0" :dataid="produs.id"   v-if="filter(produs.id)"></i>
                        <i v-else class="ri-heart-line heart_absolute nefavorit element_desktop" :datastatus="1" :dataid="produs.id"></i>
                         <div class="reducere_icon" v-if="produs.discount > 0">
                            -{{produs.discount}}%
                        </div>
                    </div>
                    <div class="box_bottom">

                        <div class="titlu_box" v-if="$i18n.locale == 'ro'">
                        {{ produs.additional.name_ro }}
                        </div>
                        <div class="titlu_box" v-else>
                        {{ produs.additional.name_en }}
                        </div>
                        <div class="reducere_icon" v-if="produs.discount > 0">
                            -{{produs.discount}}%
                        </div>
                        <div class="descriere_box" v-if="$i18n.locale == 'ro'">
                            {{produs.additional.description_ro | strippedContent}}
                        </div>
                        <div class="descriere_box" v-else>
                            {{produs.additional.description_en | strippedContent}}
                        </div>
                    </div>
                    <div class="pret_cumpara">
                  
                        <div class="box_pret_container" v-if="produs.discount > 0">
                            <div class="pret_box_taiat" >{{ produs.price }} lei</div>
                            <div class="pret_box" >{{ produs.price_final }} lei</div>
                            
                        </div>
                        <div class="box_pret_container" v-else>
                            <div class="pret_box" >{{ produs.price }} lei</div>
                        </div>
                        <div class="plus_produs"><i class="ri-add-line"></i></div>
                    </div>   
                </div>
            </div>

            <div v-else class="nici_un_produs">
                {{ $t('nici_un_produs') }}
            </div>
        </section>

        <section class="section_search containerg" v-if="produse_best_seller.length">
            <div class="titlu_search">
                {{ $t('best_sellers_result') }}
            </div>
            <div class="produse"> 
                <div :dataslug="produs.additional.slug_ro" v-for="produs in produse_best_seller" :key="produs.id" class="box_produs box_general"   @click="deschidereModalProdus(produs.id,$event)">
                <div class="positionrelative box_top">
                     <div v-if="$store.state.status_bucatarie == '2' && produs.preparing_time == 'Normal'" class="produs_indisponibil">
                        Indisponibil momentan
                    </div>
                    <div v-if="produs.main_image.length > 0">
                        <div v-for="imagine in produs.main_image.slice(0,1)" :key="imagine.thumbnailpath">
                            <img :src="imagine.thumbnailpath"/>
                        </div>
                    </div>
                    <div v-else>
                        <img src='@/assets/images/poza_default1.jpg' />
                    </div>
                    <i class="ri-heart-fill heart_absolute favorit element_desktop" :datastatus="0" :dataid="produs.id"   v-if="filter(produs.id)"></i>
                    <i v-else class="ri-heart-line heart_absolute nefavorit element_desktop" :datastatus="1" :dataid="produs.id"></i>
                     <div class="reducere_icon" v-if="produs.discount > 0">
                        -{{produs.discount}}%
                    </div>
                </div>
                <div class="box_bottom" >

                    <div class="titlu_box" v-if="$i18n.locale == 'ro'">
                    {{ produs.additional.name_ro }}
                    </div>
                    <div class="titlu_box" v-else>
                    {{ produs.additional.name_en }}
                    </div>
                    <div class="reducere_icon" v-if="produs.discount > 0">
                      -{{produs.discount}}%
                  </div>
                    <div class="descriere_box" v-if="$i18n.locale == 'ro'">
                        {{produs.additional.description_ro | strippedContent}}
                    </div>
                    <div class="descriere_box" v-else>
                        {{produs.additional.description_en | strippedContent}}
                    </div>
                    </div>
                    <div class="pret_cumpara">
                  
                        <div class="box_pret_container" v-if="produs.discount > 0">
                            <div class="pret_box_taiat" >{{ produs.price }} lei</div>
                            <div class="pret_box" >{{ produs.price_final }} lei</div>
                            
                        </div>
                        <div class="box_pret_container" v-else>
                            <div class="pret_box" >{{ produs.price }} lei</div>
                        </div>
                        <div class="plus_produs"><i class="ri-add-line"></i></div>
                    </div>   
                </div>
                </div>
        </section>
    
    </div>
    
    
</template>


<script>
  import axios from 'axios';
  import $ from 'jquery'

  export default {
      name: 'MyComponent',
      metaInfo() {
            return { 
                title: "Search | Tiki Bistro | Livrări și take-away",
                meta: [
                    { name: 'description', content:  'Descoperă toate preparatele delicioase, pregătite in micul nostru restaurant exotic.'},
                    { property: 'og:title', content: "Search | Tiki Bistro | Livrări și take-away"},
                    { property: 'og:site_name', content: 'Tiki Bistro'},
                    {property: 'og:type', content: 'website'},    
                    {name: 'robots', content: 'index,follow'} 
                ]
            }
        },
        components: {        
        },
        methods: {
           filter(id_produs){
            return this.$root.$refs.Header.filter(id_produs);
          },
          showModal_produs(){
            this.$root.$refs.Header.showModal_header_produs();
          },
          
         deschidereModalProdus(id,event) {
            this.produse_extra = []
            this.$root.$refs.Header.afisare_modal_produs(id,event);
        },
       
        },
    data() {
      return {
        produse : [],
        produse_best_seller : [],
      }
    },
    beforeMount(){
      this.produse_favorite_state = this.$store.state.products_id; 
       $('.search_header').val(this.$route.query.keywords);
    },
    mounted() {
        $('.search_header_mobile').keypress(function(event){
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                var search_key = $('.search_header_mobile').val();
                window.location.href = '/search?keywords='+search_key;
            }
            event.stopPropagation();
        });
        var currentUrl = this.$route.query.keywords;
        axios.get('https://xpanel.tikibistro.ro/api/search?t='+Number(new Date()), {
            withCredentials: false,
            params: {
                search: currentUrl
            }
            
        })
        .then((response) => {
            console.log(response.data.data);
            var array_p = [];

            response.data.data.forEach((element) => {
                console.log(element.additional.name);
                if (element.additional.name.indexOf('test') === -1)
                {
                    array_p.push(element); 
                }       
            });

            this.produse = array_p;

            if(!array_p.length)
            {
                axios.get('https://xpanel.tikibistro.ro/api/categories/1?t='+Number(new Date()), {
                    withCredentials: false,
                    params: {
                        search: currentUrl,
                        location: this.$store.state.location_shop
                    }    
                })
                .then((response) => {
                    this.produse_best_seller = response.data.data[0].products;   
                }, (error) => {
                console.log(error);
                });
            }

            
              
          }, (error) => {
          console.log(error);
        });

        
    },
    filters: {
        strippedContent: function(string) {
              return string.replace(/<\/?[^>]+>/ig, ""); 
        }
    }
    
   
  }
</script>

